import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PwaInstallService } from '../../services/pwa-install.service';

/**
 * Toolbar entry point for large screens, shown only while this device can
 * still install. Small screens get `PwaInstallFloaterComponent` instead.
 */
@Component({
  selector: 'app-pwa-install-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './pwa-install-button.component.html'
})
export class PwaInstallButtonComponent {
  private readonly pwa = inject(PwaInstallService);

  readonly visible = this.pwa.showToolbarButton;
  readonly icon =
    this.pwa.platform === 'desktop' ? 'mat:install_desktop' : 'mat:install_mobile';

  install(): void {
    this.pwa.install();
  }
}
